module.exports = __webpack_public_path__ + "img/banner_technology.9e36db5d.png";